import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetExamsParams, GetExamsStates, GetExamsStatesModel} from 'domain/usecases';

export class RemoteGetExamsStates implements GetExamsStates {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsStatesModel>,
	) {}

	async get(params?: GetExamsParams): Promise<GetExamsStatesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal: params?.signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
